import type * as THREE from "three/webgpu"

export interface TextureNodeLike {
    readonly uvNode: THREE.Node<"vec2"> | THREE.Node<"vec3"> | null

    sample(uv: THREE.Node<"vec2">): THREE.Node<"vec4">

    sampleGradient(uv: THREE.Node<"vec2">): {dFdU: THREE.Node<"vec4">; dFdV: THREE.Node<"vec4">}
}

export function isTextureNodeLike(value: unknown): value is TextureNodeLike {
    if (typeof value !== "object" || value === null) return false
    if (!("uvNode" in value)) return false
    if (!("sample" in value) || typeof value.sample !== "function") return false
    if (!("sampleGradient" in value) || typeof value.sampleGradient !== "function") return false
    return true
}
